<div style="height: 100%">
  <p-toast key="incident"></p-toast>
  <p-toast key="scheduled-maintenance" (onClose)="onScheduledMaintenanceToastClose($event)"></p-toast>
  <router-outlet></router-outlet>
</div>
